import axios from 'axios';

const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const registerUser = (userData) => apiClient.post('/users/register', userData);
export const getAllEmotions = () => apiClient.get('/emotions');
export const getNextVideo = (userId, testMode) => apiClient.get(`/videos/next?userId=${userId}&testMode=${testMode}`);
export const submitResponse = ({ userId, videoId, selectedEmotionId, testMode }) =>
  apiClient.post('/responses', { userId, videoId, selectedEmotionId, testMode });

export default apiClient;